import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import { useSelector } from '@tmapy/redux';
import { useMessage } from '@tmapy/intl';
import './Legend.scss';
import { useAGSLegend } from '../hooks/useAGSLegend';
import { useWMSLegend } from '../hooks/useWMSLegend';
import { LinkLegend, LayerLegend } from './LayerLegend';
import { LegendItem } from './LegendItem';
import { useVectorLegend } from '../hooks/useVectorLegend';
const WMSLayerLegend = (props) => {
    const { format, items } = useWMSLegend(props.layerId);
    if (!items.length)
        return _jsx(LinkLegend, { ...props });
    return (_jsx(LayerLegend, { ...props, children: format === 'json' ? (_jsx("ul", { className: 'sg-a-pb-1 sg-u-vs-1/2', children: items.map((item, idx) => (_jsx(LegendItem, { ...item }, idx))) })) : (_jsx(_Fragment, { children: items.map((item) => (_jsx("img", { src: item.imgUrl, alt: '' }))) })) }));
};
const AGSLayerLegend = (props) => {
    const agsLegendItems = useAGSLegend(props.layerId);
    if (!agsLegendItems.length)
        return _jsx(LinkLegend, { ...props });
    return (_jsx(LayerLegend, { ...props, children: _jsx("ul", { className: 'sg-a-pb-1 sg-u-vs-1/2', children: agsLegendItems.map((item, idx) => (_jsx(LegendItem, { ...item }, idx))) }) }));
};
const VectorLayerLegend = (props) => {
    const vectorLegendItems = useVectorLegend(props.layerId);
    if (!vectorLegendItems.length)
        return _jsx(LinkLegend, { ...props });
    return (_jsx(LayerLegend, { ...props, children: _jsx("ul", { className: 'sg-a-pb-1 sg-u-vs-1', children: vectorLegendItems.map((item, idx) => (_jsx(LegendItem, { ...item }, idx))) }) }));
};
export const Legend = React.memo(() => {
    const formatMessage = useMessage();
    const legends = useSelector((state) => state.legend);
    const { layers } = useSelector((state) => state.mapCore);
    const legendsWithLabel = useMemo(() => {
        return legends.map((item) => {
            return {
                ...item,
                label: formatMessage.fallback([`layer.${item.layerId}`]) || item.label || item.layerId,
            };
        });
    }, [formatMessage, legends]);
    const visibleLayerIds = useMemo(() => layers.filter((layer) => layer.layerOptions.visible).map((layer) => layer.id), [layers]);
    return (_jsx("div", { className: 'lgd-legend', children: legendsWithLabel
            .filter((legend) => visibleLayerIds.includes(legend.layerId))
            .map((visibleLegend) => {
            if (visibleLegend.imageSrc) {
                return (_jsx(LayerLegend, { ...visibleLegend, children: _jsx("img", { src: visibleLegend.imageSrc, alt: '' }) }, visibleLegend.layerId));
            }
            else {
                switch (visibleLegend.type) {
                    case 'FeatureArcGIS':
                    case 'TileArcGISRest':
                    case 'ImageArcGISRest':
                        return _jsx(AGSLayerLegend, { ...visibleLegend }, visibleLegend.layerId);
                    case 'ImageWMS':
                        return _jsx(WMSLayerLegend, { ...visibleLegend }, visibleLegend.layerId);
                    case 'VectorTile':
                    case 'Vector':
                    case 'Tile':
                        return _jsx(VectorLayerLegend, { ...visibleLegend }, visibleLegend.layerId);
                    default:
                        return _jsx(LinkLegend, { ...visibleLegend }, visibleLegend.layerId);
                }
            }
        }) }));
});
//# sourceMappingURL=Legend.js.map